import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useBulkUpdateDeviceStatus } from 'src/hooks/device';
import DeviceBulkStatusForm from './DeviceBulkStatusForm';

const DeviceBulkStatusModal = ({ open, selectedCount, deviceIds, onClose, onSaved }) => {
  const { enqueueSnackbar } = useSnackbar();
  const bulkUpdateMutation = useBulkUpdateDeviceStatus();

  const handleSubmit = async ({ status, notes, tags = [] }) => {
    const addTagIds = tags.filter(tag => tag.id).map(tag => tag.id);
    const addTagNames = tags
      .filter(tag => !tag.id)
      .map(tag => (tag.name || '').trim())
      .filter(Boolean);

    try {
      await bulkUpdateMutation.mutateAsync({
        deviceIds,
        status,
        notes: notes.trim(),
        addTagIds,
        addTagNames,
      });

      enqueueSnackbar('Device status updated successfully.', {
        variant: 'success',
        autoHideDuration: 3000,
      });
      onSaved?.();
      onClose();
    } catch (_error) {
      enqueueSnackbar('Something went wrong.', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { backgroundColor: '#3F3F3F' } }}>
      <DialogTitle>Bulk Update Status</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: '#DDDDDD', mt: 1 }}>
          {`Update ${selectedCount} selected device${selectedCount === 1 ? '' : 's'}.`}
        </Typography>
        <DeviceBulkStatusForm
          isSaving={bulkUpdateMutation.isLoading}
          onCancel={onClose}
          onSubmit={handleSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

DeviceBulkStatusModal.propTypes = {
  open: PropTypes.bool.isRequired,
  selectedCount: PropTypes.number,
  deviceIds: PropTypes.arrayOf(PropTypes.number),
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func,
};

export default DeviceBulkStatusModal;
